export function getStyleRuleConfigurationsToDisplay(
  styleRuleConfigurations,
  amountToShow,
  highlightedStyleRule,
) {
  if (highlightedStyleRule) {
    const highlightedConfig = styleRuleConfigurations.find(
      (config) => config.name === highlightedStyleRule,
    );
    const otherConfigs = styleRuleConfigurations.filter(
      (config) => config.name !== highlightedStyleRule,
    );

    if (highlightedConfig) {
      return [highlightedConfig, ...otherConfigs].slice(0, amountToShow);
    }
  }

  return styleRuleConfigurations.slice(0, amountToShow);
}
